(function () {
    'use strict';

    var opts = {
        clockFace: 'DailyCounter',
        countdown: true,
        autoplay: true,
        language: 'Custom'
    };

    /* INIT */
    $(window).ready(function () {
        var $el = $('.countdown-clock-ctn');
        if (!$el.length) {
            return;
        }

        $('.countdown-date-input .datepicker').on('blur', function () {
            var inp = this;
            setTimeout(function () {
                updateLabelLangs(inp.name, inp.value, $('html').attr('langs'), function () {
                    var output = $(inp).parents('.com-countdown-inner').find('.countdown-clock-ctn')[0];
                    output.setAttribute('data-date', inp.value);
                    initCountdown.call(output);
                }, true);
            }, 200);
        });

        $el.each(initCountdown);
    });

    function initCountdown() {
        var data = this.dataset;
        
        FlipClock.Lang.Custom = {
            days: data.langDays,
            hours: data.langHours,
            minutes: data.langMinutes,
            seconds: data.langSeconds
        };
        
        if (data.date !== '') {
            var d1 = new Date(data.date);
            var d2 = new Date();
            var countdown = (d1.getTime() - d2.getTime()) / 1000;
    
            countdown = Math.max(1, countdown);
            $(this).FlipClock(countdown, opts);
        } else {
            $(this).FlipClock(opts);
        }
    }

})();